export enum MispicksReasons {
    OnWrongLoad = "On Wrong Load",
    WrongItemSent = "Wrong Item Sent"
}